import { render } from "./PosterCaptionsComponent.vue?vue&type=template&id=1a6248d9"
import script from "./PosterCaptionsComponent.vue?vue&type=script&lang=ts"
export * from "./PosterCaptionsComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script